<template>
  <a-modal
    title="事件记录"
    :visible="visible"
    :width="600"
    @ok="onSubmit"
    @cancel="onCancel"
    cancelText="取消"
    okText="确认"
    :confirmLoading="loading">
    
    <!-- 如果没有事件类型，显示跳转链接 -->
    <div v-if="eventTypes.length === 0 && !loadingTypes" class="empty-tip">
      <a-alert 
        message="暂无事件类型" 
        description="请先添加事件类型后再创建事件记录"
        type="warning" 
        show-icon />
      <div class="link-wrapper">
        <a @click="goToEventTypes">点击跳转到事件类型管理页面</a>
      </div>
    </div>

    <!-- 有事件类型时显示表单 -->
    <a-form v-else :form="form" layout="vertical">
      <a-form-item label="事件类型" required>
        <a-select
          v-model="form.event_type_id"
          placeholder="请选择事件类型"
          :loading="loadingTypes">
          <a-select-option v-for="type in eventTypes" :key="type.id" :value="type.id">
            {{ type.name }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="是否需要处理">
        <a-radio-group v-model="form.should_handle">
          <a-radio :value="0">无需处理</a-radio>
          <a-radio :value="1">需处理</a-radio>
        </a-radio-group>
      </a-form-item>

      <a-form-item label="描述">
        <a-textarea
          v-model="form.description"
          placeholder="请输入事件描述"
          :rows="4" />
      </a-form-item>

      <a-form-item label="文件">
        <a-upload
          :file-list="fileList"
          @change="handleFileChange"
          :before-upload="beforeUpload">
          <a-button> <a-icon type="upload" /> 上传文件 </a-button>
        </a-upload>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  name: 'EventRecordModal',
  data() {
    return {
      visible: false,
      loading: false,
      loadingTypes: false,
      eventTypes: [],
      fileList: [],
      form: {
        event_type_id: undefined,
        description: '',
        files: [],
        should_handle: 0
      },
      recordable_id: null,
      recordable_type: 'breed_item'
    }
  },
  methods: {
    // 打开弹窗
    open(recordable_id) {
      this.recordable_id = recordable_id
      this.visible = true
      this.resetForm()
      this.loadEventTypes()
    },

    // 重置表单
    resetForm() {
      this.form = {
        event_type_id: undefined,
        description: '',
        files: [],
        should_handle: 0
      }
      this.fileList = []
    },

    // 加载事件类型列表（加载可以关联到breed_items的事件类型，以及通用事件类型）
    async loadEventTypes() {
      this.loadingTypes = true
      try {
        // 获取所有事件类型，然后在前端过滤
        // 包括：eventable_type 为 'breed_items' 的，或者 eventable_type 为 null 的通用事件类型
        const res = await this.$api.get_event_types_list({})
        if (res.code === 200) {
          const allTypes = res.data || []
          // 过滤出可以用于breed_items的事件类型
          this.eventTypes = allTypes.filter(type => 
            !type.eventable_type || type.eventable_type === 'breed_items'
          )
        }
      } catch (error) {
        console.error('加载事件类型失败:', error)
      } finally {
        this.loadingTypes = false
      }
    },

    // 跳转到事件类型管理页面
    goToEventTypes() {
      this.$router.push('/events/types')
      this.visible = false
    },

    // 文件上传前处理
    beforeUpload(file) {
      return false // 阻止自动上传，手动处理
    },

    // 文件变化处理
    handleFileChange({ fileList }) {
      this.fileList = fileList
    },

    // 提交
    async onSubmit() {
      if (!this.form.event_type_id) {
        this.$message.warning('请选择事件类型')
        return
      }

      this.loading = true
      try {
        const data = {
          event_type_id: this.form.event_type_id,
          description: this.form.description,
          files: this.fileList.map(f => f.name),
          recordable_type: this.recordable_type,
          recordable_id: this.recordable_id,
          should_handle: this.form.should_handle
        }

        const res = await this.$api.create_event_record(data)
        if (res.code === 200) {
          this.$message.success('事件记录创建成功')
          this.$emit('success', res.data)
          this.visible = false
        } else {
          this.$message.error(res.message || '创建失败')
        }
      } catch (error) {
        console.error('创建事件记录失败:', error)
        this.$message.error('创建失败，请重试')
      } finally {
        this.loading = false
      }
    },

    // 取消
    onCancel() {
      this.visible = false
    }
  }
}
</script>

<style scoped>
.empty-tip {
  padding: 20px 0;
}
.link-wrapper {
  margin-top: 16px;
  text-align: center;
}
.link-wrapper a {
  color: #1890ff;
  cursor: pointer;
}
</style>
